import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics を TypeScript で型安全に使用するための拡張
declare global {
  interface Window {
    gtag: (command: string, targetId: string, config?: any) => void;
  }
}

/**
 * Google Analytics のページビューを追跡するカスタムHook
 * React Router の場所変更を監視して自動的にページビューを送信
 */
export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Google Analytics が読み込まれているかチェック
    if (typeof window.gtag !== 'undefined') {
      // ページビューを送信
      window.gtag('config', 'G-V7580N6YNS', {
        page_path: location.pathname + location.search,
      });
      
      console.log('GA Page View:', location.pathname + location.search);
    }
  }, [location]);
};

/**
 * カスタムイベントを送信するヘルパー関数
 * @param action イベントアクション名
 * @param category イベントカテゴリ
 * @param label イベントラベル（オプション）
 * @param value イベント値（オプション）
 */
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
    
    console.log('GA Event:', { action, category, label, value });
  }
};

/**
 * よく使用されるイベント追跡関数
 */
export const GAEvents = {
  // 口コミ関連
  reviewSubmit: () => trackEvent('submit_review', 'engagement', 'review_form'),
  reviewView: (reviewId: string) => trackEvent('view_review', 'engagement', reviewId),
  
  // 検索関連
  search: (query: string) => trackEvent('search', 'engagement', query),
  filterApply: (filterType: string) => trackEvent('filter_apply', 'search', filterType),
  
  // ナビゲーション関連
  pageView: (pageName: string) => trackEvent('page_view', 'navigation', pageName),
  buttonClick: (buttonName: string) => trackEvent('button_click', 'interaction', buttonName),
  
  // 認証関連
  login: (method: string) => trackEvent('login', 'auth', method),
  signup: (method: string) => trackEvent('sign_up', 'auth', method),
  logout: () => trackEvent('logout', 'auth'),
  
  // エラー関連
  error: (errorType: string, errorMessage?: string) => 
    trackEvent('error', 'system', errorType, errorMessage ? 1 : 0),
};
